import { Drawer, Empty, Tag, Tooltip } from 'antd'
import React from 'react'
import { camelCaseString, dateFormatter } from '../../../../config/Global';
import { CloudDownloadOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const LogHistory: React.FC<any> = ({ visibleLog, closeLogDrawer, logData }) => {
    const Message = (data: any) => {
        return (
            <div className='msgBox'>
                {data?.provider_name && <span className="message-name">{data.provider_name}</span>}
                {data?.updated_at && <span className="message-date">{(data?.provider_name) && ","}{dateFormatter(data.updated_at)}</span>}
                {data?.reason &&
                    <div className={'message'}>
                        {
                            data?.status &&
                            <div className='status'>
                                Status:&nbsp;
                                {
                                    <Tag
                                        color={
                                            data.status === "in progress" ? "processing"
                                                : data.status === "completed" ? "success"
                                                    : "error"
                                        }
                                    >
                                        {camelCaseString(data.status)}
                                    </Tag>
                                }
                            </div>
                        }
                        {
                            data.file_download_link &&
                            <div className='downloadFile'>
                                <Tooltip title="Download your uploaded file.">
                                    <Link target='_blank' to={data.file_download_link}>
                                        <CloudDownloadOutlined />
                                    </Link>
                                </Tooltip>
                            </div>
                        }
                        {data?.reason && <div className="message-des">{data.reason}</div>}
                    </div>
                }
            </div>
        );
    };

    return (
        <Drawer
            open={visibleLog}
            destroyOnClose
            width={1100}
            onClose={closeLogDrawer}
            footer={false}
            className="addModal"
            title={`View Status Log`}
        >
            <div className="chat-container">
                {logData?.length > 0 ?
                    <ul>
                        {logData.map((item: any, index: number) => {
                            return (
                                <li key={index} className={item.from}>
                                    {Message(item)}
                                </li>
                            )
                        })}
                    </ul>
                    : <Empty />
                }
            </div>
        </Drawer>
    )
}

export default LogHistory